import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const NormalizerField = ({ className, name = "code", label = "Normalizers", ...restProps }) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.normalizer}
        label={label}
        {...restProps}
    />
);
